import { addDays, subYears, format } from 'date-fns'

import {
  getCredits,
  getCreditsGroup,
} from '../api/bernabeu';

import {
  creditSlice,
  callTypes
} from "../../redux/reducers/creditSlice";

const { actions } = creditSlice;

const fetchCredits = (originid = '', duration = '', statusId = '', startAt = '', originType = '') => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    let params: any = {
      sort: '-createdAt',
    };

    if (originid) {
      params.origin_id = originid;
    }

    if (duration) {
      params.duration = duration;
      params.expired_at = format(new Date(), 'yyyy-MM-dd');
    }

    if (statusId) {
      params.status_id = statusId;
    }

    if (startAt) {
      params.start_at = startAt;
    }
    if (originType) {
      params.origin_type = originType;
    }

    getCredits(params).then((response: any) => {
      resolve(response.data);

      dispatch(actions.creditsFetched());

    }).catch((error) => {
      console.log('fetchCredits falhou:');
      console.log({error});

      dispatch(actions.creditsFetched());

      reject(false);
    });
  });
}

const fetchCredit = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getCredits({ id: id }).then((response: any) => {
      resolve(response.data[0]);

      dispatch(actions.creditsFetched());
    }).catch((error) => {
      console.log('fetchCreditPurchases falhou:');
      console.log({error});
      dispatch(actions.creditsFetched());

      reject(false);
    });
  });
}

const fetchCreditsGroup = (originType = '') => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getCreditsGroup({
      origin_type: originType,
      status_id: 'active',
      date: format(new Date(), 'yyyy-MM-dd')
    }).then((response: any) => {
      resolve(response.data);

      dispatch(actions.creditsFetched());

    }).catch((error) => {
      console.log('fetchCreditsGroup falhou:');
      console.log({error});

      dispatch(actions.creditsFetched());

      reject(false);
    });
  });
}

export {
  fetchCredits,
  fetchCredit,
  fetchCreditsGroup,
}